import { Text } from '@billy/design-system'
import { ReactElement } from 'react'

import { invoicePreviewRibbonVariantStyles } from './constants/invoicePreviewRibbonVariantStyles'
import * as Styled from './styles'
import { InvoicePreviewRibbonVariant } from './types/invoicePreviewRibbonVariant'

interface InvoicePreviewRibbonProps {
  text: string
  variant: InvoicePreviewRibbonVariant
}

export const InvoicePreviewRibbon = ({ text, variant }: InvoicePreviewRibbonProps): ReactElement => {
  return (
    <Styled.InvoicePreviewRibbonWrapper>
      <Styled.InvoicePreviewRibbonItem variant={variant}>
        <Text
          alignment="center"
          color={invoicePreviewRibbonVariantStyles[variant].textColor}
          variant="bodySM"
          weight="bold"
        >
          {text}
        </Text>
      </Styled.InvoicePreviewRibbonItem>
    </Styled.InvoicePreviewRibbonWrapper>
  )
}
